import { DiagnosticsSnapshot } from './diagnosticsTypes';
import { serializeDiagnosticsSnapshot } from './diagnosticsSerializer';

interface BugTicketBuilderOptions {
  details: string;
  reportedAt: string;
  currentUrl: string;
  activeLayerId?: number | null;
  mapZoom?: number;
  reporterName?: string | null;
  reporterUserId?: string | null;
  diagnostics: DiagnosticsSnapshot;
}

export function buildBugTicketDescription(options: BugTicketBuilderOptions): string {
  const runtimeContext = [
    '## Runtime Context',
    `- Reported At (UTC): ${options.reportedAt}`,
    `- URL: ${options.currentUrl || 'unknown'}`,
    `- Active Layer ID: ${options.activeLayerId ?? 'unknown'}`,
    `- Map Zoom: ${options.mapZoom ?? 'unknown'}`,
    `- Reporter Name: ${options.reporterName || 'unknown'}`,
    `- Reporter User ID: ${options.reporterUserId || 'unknown'}`,
    '',
  ];

  return [
    '## Bug Report',
    '',
    options.details.trim(),
    '',
    ...runtimeContext,
    serializeDiagnosticsSnapshot(options.diagnostics),
  ].join('\n');
}
